import { Button, Form, Input, Modal } from "antd";
import React from "react";
import Header from "../common/Header";
import { TiEdit } from "react-icons/ti";
import Loading from "../common/Loading/loading";

const SettingComponent = (props) => {
  const {
    handelModalOpen,
    confirmModal,
    handleCancelModal,
    handleInputChange,
    handleEditDetails,
    formValues,
    formErrors,
    adminDetails,
    handleLogOutScreen,
    spinLoader,
    handleNewChangePin,
    handleConfirmLogOutScreen,
    setOpenModal,
    openModal,
  } = props;
  const onChange = (text) => {
  };
  const sharedProps = {
    onChange,
  };
  return (
    <>
      <div className="setting-main-container">
        <Header title="Setting" />
        <div className="main-container">
          <div className="setting-details-container">
            <div className="profile-section">
              <div className="title-container">
                <p className="profile-text">Profile</p>
              </div>

              <div className="details-container">
                <div className="details-form">
                  <p>Name</p>
                  <Input
                    size="large"
                    className="input-field"
                    placeholder="Enter Name"
                    name="phone_number"
                    value={adminDetails?.name}
                    disabled={true}
                  />
                </div>
                <div className="details-form">
                  <p>Mobile Number</p>
                  <Input
                    size="large"
                    className="input-field"
                    placeholder="Enter Mobile Number"
                    name="phone_number"
                    value={adminDetails?.phone_number}
                    disabled={true}
                    prefix={
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg"
                          alt="India Flag"
                          style={{ width: 20, height: 15, marginRight: 5 }}
                        />
                        <span>+91</span>
                      </span>
                    }
                  />
                </div>
                <div className="details-form">
                  <p>Reset PIN</p>
                  <div className="password-container">
                    <Input.Password
                      size="large"
                      className="password-field"
                      placeholder="Enter Current PIN"
                      name="phone_number"
                      value="****"
                      disabled={true}
                    />
                    <TiEdit className="edit-icon" onClick={handelModalOpen} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="logout-container">
            <p className="logout-title">Log Out</p>
            <div className="logout-desc">
              <p>
                Leave your account and ensure your data remains private. By
                logging out, you’ll help protect your personal information and
                ensure that your session is secure.
              </p>
              <button className="logout-btn" onClick={handleLogOutScreen}>
                Log out
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        centered
        open={confirmModal}
        onCancel={handleCancelModal}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        className="profile-popup-edit password-reset"
      >
        <div className="user-delete-confirm-model">
          <div className="image-container">Reset PIN</div>
          <Form>
            <div className="user-delete-text">
              <label className="reset-pass-email-label">
                <span className="required">*</span> Current PIN
              </label>
              <Input.OTP
                {...sharedProps}
                length={4}
                className="errorInput"
                placeholder="Enter Current Password"
                name="currentpassword"
                type="password"
                onChange={handleInputChange}
                value={formValues.currentpassword}
                inputMode="numeric"
                style={{
                  WebkitTextSecurity: "disc",
                }}
              />
              {formErrors.currentpassword && (
                <p
                  style={{
                    color: "red",
                    paddingBottom: "3px",
                    fontSize: "14px",
                  }}
                >
                  {formErrors.currentpassword}
                </p>
              )}
            </div>
            <div className="user-delete-text">
              <label className="reset-pass-email-label">
                <span className="required">*</span> New PIN
              </label>
              <Input.OTP
                {...sharedProps}
                length={4}
                name="newpassword"
                placeholder="Enter New Password"
                type="password"
                className="errorInput"
                onChange={handleNewChangePin}
                value={formValues.newpassword}
              />
              {formErrors.newpassword && (
                <p
                  style={{
                    color: "red",
                    paddingBottom: "3px",
                    fontSize: "14px",
                  }}
                >
                  {formErrors.newpassword}
                </p>
              )}
            </div>

            <div className="button-all">
              <Button
                type="primary"
                danger
                className="user-delete-button"
                onClick={handleCancelModal}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                className="user-delete-yes-button"
                onClick={handleEditDetails}
              >
                {spinLoader ? <Loading type="spinner" color="#fff" /> : " Save"}
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
      <Modal
        centered
        open={openModal}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => setOpenModal(false)}
        className="approve-popup"
      >
        <div
          style={{
            padding: "30px",
            textAlign: "center",
            backgroundColor: "#fefefe",
            borderRadius: "16px",
          }}
        >
          <div
            style={{
              fontSize: "20px",
              fontWeight: "600",
              marginBottom: "16px",
              color: "#333",
            }}
          >
            Are you sure you want to log out ?
          </div>
          <div
            style={{
              fontSize: "16px",
              color: "#777",
              marginBottom: "24px",
              lineHeight: "1.5",
            }}
          >
            We’ll miss you! 💙
            <br />
            Take care and see you again soon!
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <Button
              type="primary"
              danger
              className="user-delete-button"
              onClick={() => setOpenModal(false)}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
                backgroundColor: "#ff7875",
                borderColor: "#ff7875",
              }}
            >
              Stay Here ❤️
            </Button>
            <Button
              type="primary"
              className="user-delete-yes-button"
              onClick={handleConfirmLogOutScreen}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
                backgroundColor: "#d6ad61",
                borderColor: "#d6ad61",
              }}
            >
              Log Out
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SettingComponent;
